import {
  Button, Grid,
  Layout,
  Space
} from "antd";
import { useTranslation } from "react-i18next";
import classes from "./header.module.css";
import Notifications from "../Notifications";
import useAssistance from "../../hooks/useAssistance";

const {
  Header: AntHeader,
} = Layout;

const Header = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { toggleAssistModal } = useAssistance();

  return !screens.lg ? null : (
    <AntHeader className={classes.root}>
      <Space size={24}>
        <Notifications/>
        <Button type="primary" size="large" onClick={toggleAssistModal}>{t("global.header.assistant")}</Button>
      </Space>
    </AntHeader>
  );
};

export default Header;
